/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {BrowserExcludeDirective as ɵb} from './lib/browser-exclude.directive';
export {SSRExcludeDirective as ɵa} from './lib/ssr-exclude.directive';